import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 9.99999C18.3334 5.39762 14.6025 1.66666 10.0001 1.66666C5.39771 1.66666 1.66675 5.39762 1.66675 9.99999C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333ZM12.5001 8.33332C12.5001 9.71404 11.3808 10.8333 10.0001 10.8333C8.61937 10.8333 7.50008 9.71404 7.50008 8.33332C7.50008 6.95261 8.61937 5.83332 10.0001 5.83332C11.3808 5.83332 12.5001 6.95261 12.5001 8.33332ZM10.0002 16.6667C8.13493 16.6667 6.44853 15.9006 5.23853 14.6659C6.3483 13.3375 8.00417 12.5 10.0002 12.5C11.9963 12.5 13.6522 13.3375 14.762 14.6659C13.552 15.9006 11.8656 16.6667 10.0002 16.6667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }